<template>
  <validation-observer ref="form" slim>
    <div class="form-container">
      <div class="wrapper">
        <fields :detail="detail" :isSubmit.sync="is_submit" />
      </div>
      <heavy-equipment-rental
        :detail="detail"
      />
      <work-volume
        :detail="detail"
        :canAdd="canAdd"
        :calculate="calculate"
        :fuelPrice="fuelPrice.fuel_price_idr"
        :isSubmit.sync="is_submit"
        @add="addWorkVolume"
        @remove="removeWorkVolume"
      />
      <div class="d-flex mt-5">
        <div id="history">
          <b-button
            ref="button"
            class="btn-custom mr-2"
            variant="info"
            size="sm"
            @click="isHidden = !isHidden"
          >
          Log History
          </b-button>
          <b-card
            class="log-history text-center"
            v-show="isHidden"
            v-closable="{
              exclude: ['button'],
              handler: 'onClose'
            }"
          >
            <div class="timeline small">
              <div v-if="detail.approval_history && detail.approval_history.length > 0">
                <ul class="list-history">
                  <li
                    class="list-history-child"
                    v-for="(info, index) in detail.approval_history"
                    v-bind:key="index">
                    <div class="timeline-log timeline-name">
                      {{ info.fullname }} - {{ info.event }}
                    </div>
                    <div class="timeline-log timeline-status">
                      {{ info.state }}
                    </div>
                    <div class="timeline-log">
                      {{ info.comment }}
                    </div>
                    <div class="timeline-log timeline-date mb-3">
                      {{ `${formatDate(info.created_at)}` }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="no-history" v-else>
                <h5>There is no data history in here.</h5>
              </div>
            </div>
          </b-card>
        </div>
        <div class="d-flex flex-fill">
          <b-button
            class="btn-reset mr-2"
            variant="outline-info"
            size="sm"
            @click="onClickBack"
          >
            Back
          </b-button>
          <b-button
            v-if="canPrint"
            class="btn-custom mr-auto"
            variant="info"
            size="sm"
            @click="onPrint"
          >
            Export
          </b-button>
          <b-button
            v-if="canAdd && detail.status === 'Draft'"
            class="btn-custom ml-auto mr-2"
            variant="info"
            size="sm"
            @click="saveAsDraft"
            :disabled="isLoading"
          >
            Save as Draft
          </b-button>
          <b-button
            v-if="canAdd && (detail.status === 'Draft' || detail.status === 'Revise')"
            class="btn-custom"
            variant="info"
            size="sm"
            @click="onSubmit"
            :disabled="isLoading"
          >
            Submit
          </b-button>
          <b-button
            v-if="detail.approval_status.isActiveRevise"
            class="btn-revise-cstm mr-2 ml-auto"
            variant="danger"
            size="sm"
            @click="onRevise"
            :disabled="isLoading"
          >
            Revise
          </b-button>
          <b-button
            v-if="detail.approval_status.isActiveApprove"
            class="btn-custom"
            variant="info" size="sm"
            @click="onApprove"
            :disabled="isLoading"
          >
            Approve
          </b-button>
        </div>
      </div>
      <modal-approve @submit="showComment" :form="detail" :text="text" />
      <modal-comment @submit="updateStatus" :action="action" />
      <modal-confirm @submit="submitBackupPayment" />
      <modal-successful :message="text" />
    </div>
  </validation-observer>
</template>

<script>
import { hasPermission } from '@/utils/permissions'
import Fields from './Field'
import HeavyEquipmentRental from './HeavyEquipmentRental'
import WorkVolume from './WorkVolume'
import { BACKUP_PAYMENT_ADD, BACKUP_PAYMENT_PRINT } from '@/fixtures'
import ModalApprove from '@/partials/ModalApprove'
import ModalComment from '@/partials/ModalComment'
import ModalConfirm from './ModalConfirm'
import ModalSuccessful from '@/partials/ModalSuccessful'
import api from '@/api'
import moment from 'moment'
import { closeEvent } from '@/utils/closeEvent'

closeEvent()

export default {
  components: {
    Fields,
    HeavyEquipmentRental,
    WorkVolume,
    ModalApprove,
    ModalComment,
    ModalConfirm,
    ModalSuccessful
  },

  data: () => ({
    bup: {
      id: null,
      contractorId: null,
      periodeStart: null,
      periodeEnd: null
    },
    isNew: true,
    isHidden: false,
    canPrint: hasPermission(BACKUP_PAYMENT_PRINT),
    canAdd: hasPermission(BACKUP_PAYMENT_ADD),
    action: '',
    text: '',
    detail: {
      approval_status: {
        isisActiveRevise: false
      }
    },
    calculate: [],
    fuelPrice: {},
    is_submit: false,
    is_draft: false,
    isLoading: false
  }),

  created() {
    if (this.$route.query.bup_id && this.$route.query.bup_id > 0) {
      this.bup.id = this.$route.query.bup_id
    } else {
      this.isNew = false
    }
    if (this.$route.query.contractor_id && this.$route.query.contractor_id > 0) {
      this.bup.contractorId = this.$route.query.contractor_id
      this.bup.periodeStart = this.$route.query.periode_start
      this.bup.periodeEnd = this.$route.query.periode_end
    }

    this.fetchDetailBackupPayment()
  },

  methods: {
    async fetchDetailBackupPayment() {
      const options = this.bup.id ? { id: this.bup.id } : { contractor_id: this.bup.contractorId, periode_start: this.bup.periodeStart, periode_end: this.bup.periodeEnd }
      this.detail = await api.backupPayment.get(options)
      if (!this.detail.id && this.detail.status === 'Draft') {
        this.detail.approval_status = {
          isisActiveRevise: false,
          isActiveApprove: false,
          isEdit: this.canAdd
        }
      }
      this.fetchCalculate()

      let totalPaymentAmount = 0
      this.detail.equipment.forEach(d => {
        d.rowBUP.map(d => {
          totalPaymentAmount += d.payment_amount
        })
      })
      this.detail.grant_total_payable = totalPaymentAmount
      this.detail.grant_total_payable_vat = this.detail.grant_total_payable * 1.11
      this.fetchFuelPrice()
    },
    async fetchCalculate() {
      const options = { contractor_id: this.detail.contractor_id }
      this.calculate = await api.backupPayment.calculate(options)
    },
    async fetchFuelPrice() {
      this.fuelPrice = await api.rate.fuelPrice({
        date: this.detail.payment_period_start ? moment(this.detail.payment_period_start).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      })
    },
    onClickBack() {
      this.$router.push('/bup-rental-equipment')
    },
    onApprove() {
      this.text = 'Approve this summary hm ewh'
      this.action = 'approve'
      this.$bvModal.show('modal-approve')
    },
    onRevise() {
      this.text = 'Revise this summary hm ewh'
      this.action = 'revise'
      this.$bvModal.show('modal-approve')
    },
    showComment() {
      this.$bvModal.show('modal-comment')
    },
    onPrint() {
      const url = `${process.env.VUE_APP_PRINT_URL}/BackupPayment?ContractorId=${this.detail.contractor_id}&BupId=${this.detail.id ?? 0}`
      window.open(url)
    },
    onSubmit() {
      this.$bvModal.show('modal-confirm')
    },
    onClose() {
      this.isHidden = false
    },
    async updateStatus(comment) {
      try {
        this.isLoading = true
        const checkStatus = this.action === 'approve'
          ? await api.backupPayment.approve(this.detail.id, comment)
          : await api.backupPayment.revise(this.detail.id, comment)
        if (checkStatus.data.error) {
          this.isLoading = false
          this.$nextTick(() => {
            this.$bvToast.toast(`${checkStatus.data.error.message}`, {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          })
        } else {
          this.text = this.action === 'approve' ? 'Approve this rental equipment' : 'Revise this rental equipment'
          this.$bvModal.show('modal-successful')
          setTimeout(() => {
            this.$router.push('/rental-equipent')
          }, 2000)
        }
      } catch ({ response }) {
        this.isLoading = false
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async submitBackupPayment() {
      this.is_draft = false
      this.is_submit = true
      try {
        this.isLoading = true
        const valid = await this.$refs.form.validate()
        if (!valid) {
          this.$nextTick(() => this.$refs.input.focus())
          return false
        }
        const form = this.prepareForm()
        if (this.bup.id) {
          await api.backupPayment.update(this.bup.id, form)
        } else {
          await api.backupPayment.submit(form)
        }
        this.text = 'Submit this rental equipment'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          this.$router.push('/bup-rental-equipment')
        }, 2000)
      } catch ({ response }) {
        this.isLoading = false
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    addWorkVolume() {
      this.detail.volume.push({
        type_work_source: '',
        type_work_purpose: '',
        actual_distance: 0,
        payment_distance: 0,
        volume_bcm: 0,
        volume_price: 0,
        total_price: 0,
        cc: '',
        plan: '',
        ac: '',
        sub_ac: '',
        pa: ''
      })
    },
    removeWorkVolume(index) {
      this.detail.volume = [
        ...this.detail.volume.slice(0, index),
        ...this.detail.volume.slice(index + 1)
      ]
    },
    async saveAsDraft() {
      this.is_draft = true
      this.is_submit = false
      this.submitCommit()
    },
    async submitCommit() {
      try {
        this.isLoading = true
        const form = this.prepareForm()
        if (this.bup.id) {
          await api.backupPayment.update(this.bup.id, form)
        } else {
          await api.backupPayment.submit(form)
        }
        this.text = 'save as draft'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          this.$router.push('/bup-rental-equipment')
        }, 1500)
      } catch ({ response }) {
        this.isLoading = false
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    prepareForm() {
      this.detail.volume.map(d => {
        d.budget_code = d.cc + '-' + d.plan + '-' + d.ac + '-' + d.sub_ac + '-' + d.pa
      })
      return {
        contractor_id: this.detail.contractor_id,
        company_id: this.detail.company_id,
        invoice_number: this.detail.invoice_number ? this.detail.invoice_number : null,
        is_draft: this.is_draft,
        is_submit: this.is_submit,
        grant_total_payable: parseFloat(this.detail.grant_total_payable),
        grant_total_payable_vat: this.detail.grant_total_payable_vat,
        equipment: this.detail.equipment,
        summaryProgressId: this.detail.summaryProgressId,
        volume_work: this.detail.volume,
        payment_period_start: this.detail.payment_period_start,
        payment_period_end: this.detail.payment_period_end
      }
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY')
    }
  },

  destroyed() {
    localStorage.removeItem('currentPage', this.currentPage)
    localStorage.removeItem('totalRows', this.totalRows)
  }
}
</script>

<style>
.form-control {
  font-size: 12px;
}

.col-form-label,
.col-form-label-sm {
  font-size: 12px !important;
}
</style>
